import React from "react";
import { ReactComponent as HomeIcon } from "../../assets/icons/home.svg";
import { ReactComponent as ChevronRight } from "../../assets/icons/chevron-right.svg";
import { BREADCRUMBS_TRANSLATIONS } from "../../translations/util";

const getUrlForPath = (path: string) => {
  switch (path.toLowerCase()) {
    case "cannedmessages":
      return "/configurationManagement/cannedmessages";
    case "lmrgroups":
      return "/configurationManagement/lmrgroups";
    case "lmrusers":
      return "/configurationManagement/lmrusers";
    case "mcpttgroups":
      return "/configurationManagement/mcpttGroups";
    case "mcpttusers":
      return "/configurationManagement/mcpttUsers";
    case "dfsiconnections":
      return "/configurationManagement/dfsiConnections";
    case "dfsichannels":
      return "/configurationManagement/dfsiChannels";
    case "dfsigroups":
      return "/configurationManagement/dfsiGroups";
    case "locations":
      return "/configurationManagement/locations";
    case "organizationmapping":
      return "/configurationManagement/organizationmapping";
    case "organizations":
      return "/configurationManagement/organizations";
    case "organizationtranslation":
      return "/configurationManagement/organizationtranslation";
    case "otarconnections":
      return "/configurationManagement/otarconnections";
    case "xssiconnections":
      return "/configurationManagement/xssiconnections";
    case "ikiconnections":
      return "/configurationManagement/ikiconnections";
    case "activealarms":
      return "/faultManagement/ActiveAlarms";
    case "faults":
      return "/faultManagement/faults";
    case "inventory":
      return "/faultManagement/inventory";
    case "instances":
      return "/faultManagement/instances";
    case "historicalalarms":
      return "/faultManagement/HistoricalAlarms";
    case "publishinfo":
      return "/realtime/publishinfo";
    case "p25unit":
      return "/realtime/p25unit";
    case "p25group":
      return "/realtime/p25group";
    case "fixednetworkelement":
      return "/realtime/fixednetworkelement";
    case "p25affiliations":
      return "/realtime/p25affiliations";
    case "overview":
      return "/overview";
    case "configurationmanagement":
      return "#";
    case "faultmanagement":
      return "#";
    case "realtime":
      return "#";
    case "new":
      return "#";
    case "bulk":
      return "#";
    default:
      return "/overview";
  }
};

const getTextForPath = (path: string) => {
  switch (path.toLowerCase()) {
    case "configurationmanagement":
      return BREADCRUMBS_TRANSLATIONS.configurationmanagement;
    case "cannedmessages":
      return BREADCRUMBS_TRANSLATIONS.cannedmessages;
    case "lmrgroups":
      return BREADCRUMBS_TRANSLATIONS.lmrgroups;
    case "lmrusers":
      return BREADCRUMBS_TRANSLATIONS.lmrusers;
    case "mcpttgroups":
      return BREADCRUMBS_TRANSLATIONS.mcpttgroups;
    case "dfsiconnections":
      return BREADCRUMBS_TRANSLATIONS.dfsiconnections;
    case "dfsichannels":
      return BREADCRUMBS_TRANSLATIONS.dfsichannels;
    case "dfsigroups":
      return BREADCRUMBS_TRANSLATIONS.dfsigroups;
    case "mcpttusers":
      return BREADCRUMBS_TRANSLATIONS.mcpttusers;
    case "locations":
      return BREADCRUMBS_TRANSLATIONS.locations;
    case "organizationmapping":
      return BREADCRUMBS_TRANSLATIONS.organizationmapping;
    case "organizations":
      return BREADCRUMBS_TRANSLATIONS.organizations;
    case "organizationtranslation":
      return BREADCRUMBS_TRANSLATIONS.organizationtranslation;
    case "otarconnections":
      return BREADCRUMBS_TRANSLATIONS.otarconnections;
    case "xssiconnections":
      return BREADCRUMBS_TRANSLATIONS.xssiconnections;
    case "ikiconnections":
      return BREADCRUMBS_TRANSLATIONS.ikiconnections;
    case "new":
      return BREADCRUMBS_TRANSLATIONS.new;
    case "bulk":
      return BREADCRUMBS_TRANSLATIONS.bulk;
    case "faultmanagement":
      return BREADCRUMBS_TRANSLATIONS.faultmanagement;
    case "activealarms":
      return BREADCRUMBS_TRANSLATIONS.activealarms;
    case "faults":
      return BREADCRUMBS_TRANSLATIONS.faults;
    case "inventory":
      return BREADCRUMBS_TRANSLATIONS.inventory;
    case "instances":
      return BREADCRUMBS_TRANSLATIONS.instances;
    case "historicalalarms":
      return BREADCRUMBS_TRANSLATIONS.historicalalarms;
    case "realtime":
      return BREADCRUMBS_TRANSLATIONS.realtime;
    case "publishinfo":
      return BREADCRUMBS_TRANSLATIONS.publishinfo;
    case "p25unit":
      return BREADCRUMBS_TRANSLATIONS.p25unit;
    case "p25group":
      return BREADCRUMBS_TRANSLATIONS.p25group;
    case "fixednetworkelement":
      return BREADCRUMBS_TRANSLATIONS.fixednetworkelement;
    case "p25affiliations":
      return BREADCRUMBS_TRANSLATIONS.p25groupaffiliations;
    case "overview":
      return BREADCRUMBS_TRANSLATIONS.overview;
    default:
      return BREADCRUMBS_TRANSLATIONS.default;
  }
};

const Breadcrumps = () => {
  const path = window.location.pathname.split("/");
  return (
    <div className="inline-flex items-center space-x-1 md:space-x-3 breadcrumb-wrapper">
      {path.map((p) => {
        return (
          <div
            key={p}
            className="inline-flex items-center"
            data-cy={`breadcrumb-${getTextForPath(p).replace(" ", "")}`}
          >
            <a
              href={getUrlForPath(p)}
              className="inline-flex items-center breadcrumb-item"
            >
              {p.length > 0 ? <ChevronRight /> : <HomeIcon />}
              {getTextForPath(p)}
            </a>
          </div>
        );
      })}
    </div>
  );
};

export default Breadcrumps;
